import axiosInstance from '@/services/api/axios';

export interface AntifraudBlock {
  id: string; merchant_id: string | null; merchant_name: string | null;
  client_user_id: string; scope: 'MERCHANT' | 'GLOBAL'; reason: string;
  source: 'AUTO' | 'MANUAL'; status: 'ACTIVE' | 'EXPIRED' | 'DISABLED';
  rule_code: string | null; blocked_until: string | null; is_permanent: boolean;
  created_by_username: string | null; created_at: string;
}

export interface AntifraudEvent {
  id: string; merchant_name: string; client_user_id: string;
  payment_system: string | null; rule_code: string;
  action: 'ALLOW' | 'REJECT' | 'BLOCK' | 'MONITOR'; details: Record<string, unknown>; created_at: string;
}

export interface AntifraudAppealVerdict {
  id: string; source: string; source_appeal_id: number;
  transaction_id: string | null; merchant_name: string | null;
  client_user_id: string | null; verdict: string; verdict_at: string;
  is_active: boolean; updated_at: string;
}

export interface AntifraudThreshold {
  id?: string; min_success_count: number; max_success_count: number | null;
  max_accepted: number; max_declined: number; priority?: number;
}

export interface AntifraudSettings {
  is_enabled: boolean; mode: 'MONITORING' | 'ENFORCING'; history_limit: number;
  temporary_block_hours: number; exclude_sandbox: boolean;
  fake_check_enabled: boolean; fake_check_mode: 'MONITORING' | 'ENFORCING';
  fake_check_threshold: number; fake_check_window_days: number;
  fake_check_block_hours: number; fake_check_scope: 'MERCHANT' | 'GLOBAL';
  fake_check_exclude_sandbox: boolean;
  updated_by_username?: string | null; updated_at?: string;
  thresholds: AntifraudThreshold[];
}

export interface AntifraudBlocksResponse {
  items: AntifraudBlock[];
  total: number;
  page: number;
  size: number;
}

export const antifraudService = {
  listBlocks: async (params: Record<string, unknown> = {}) =>
    (await axiosInstance.get('/antifraud/blocks', { params })).data as AntifraudBlocksResponse,
  createBlock: async (data: Record<string, unknown>) =>
    (await axiosInstance.post('/antifraud/blocks', data)).data as AntifraudBlock,
  disableBlock: async (id: string) =>
    (await axiosInstance.post(`/antifraud/blocks/${id}/disable`)).data as AntifraudBlock,
  listEvents: async (params: Record<string, unknown> = {}) =>
    (await axiosInstance.get('/antifraud/events', { params })).data as AntifraudEvent[],
  listAppealVerdicts: async (params: Record<string, unknown> = {}) =>
    (await axiosInstance.get('/antifraud/appeal-verdicts', { params })).data as AntifraudAppealVerdict[],
  getSettings: async () =>
    (await axiosInstance.get('/antifraud/settings')).data as AntifraudSettings,
  updateSettings: async (data: AntifraudSettings) =>
    (await axiosInstance.put('/antifraud/settings', data)).data as AntifraudSettings,
};
